











































import {
  computed,
  defineComponent,
  onBeforeUnmount,
  onMounted,
  PropType,
  ref,
} from '@nuxtjs/composition-api'
import { IHolidayTheme } from '@/contracts/Settings'

export default defineComponent({
  name: 'MediatorItem',
  props: {
    compFunc: {
      type: Function as PropType<() => Promise<any>>,
      required: true,
    },
    value: {
      type: Object as PropType<Record<string, any>>,
      default: () => ({}),
    },
    type: {
      type: String,
      required: true,
    },
    eager: {
      type: Boolean,
      default: false,
    },
    needBreadCrumbs: {
      type: Boolean,
      default: false,
    },
    hideDelimiters: {
      type: Boolean,
      default: false,
    },
    holidayTheme: {
      type: Object as PropType<IHolidayTheme>,
      required: true,
    },
    isDebugTemplatesShown: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const el = ref<HTMLElement | null>(null)
    // SSR: рендерим всё для SEO.
    // Клиент: eager-секции видны сразу, остальные ждут IntersectionObserver.
    const isVisible = ref(process.server || props.eager)
    let observer: IntersectionObserver | null = null

    const isDarkTheme = computed(() => !!(props.value as any)?.isDarkTheme)

    const showHolidaySide = computed(
      () => props.holidayTheme.themeActive && !!props.holidayTheme.themeSide
    )

    const showHolidayDelimiter = computed(
      () => props.holidayTheme.themeActive && !!props.holidayTheme.themeDelimiter
    )

    const holidaySideStyle = computed(() => ({
      backgroundImage: `url(${props.holidayTheme.themeSide})`,
    }))

    onMounted(() => {
      if (isVisible.value) return
      if (!el.value || typeof IntersectionObserver === 'undefined') {
        isVisible.value = true
        return
      }
      observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            isVisible.value = true
            observer?.disconnect()
            observer = null
          }
        },
        { rootMargin: '200px 0px' }
      )
      observer.observe(el.value)
    })

    onBeforeUnmount(() => {
      observer?.disconnect()
    })

    return {
      el,
      isVisible,
      isDarkTheme,
      showHolidaySide,
      showHolidayDelimiter,
      holidaySideStyle,
    }
  },
})
